import { render } from "./LegoPrivacyPolicy.vue?vue&type=template&id=b82ec9ce"
import script from "./LegoPrivacyPolicy.vue?vue&type=script&lang=js"
export * from "./LegoPrivacyPolicy.vue?vue&type=script&lang=js"
script.render = render

export default script